<template>
  <div
    v-if="
      (symptomRecordStep === false && treatmentStep === false) ||
      (symptomRecordStep === true && treatmentStep === true)
    "
  >
    <div>
      <div
        id="row"
        class="tw-items-center tw-px-2 tw-pb-4 tw-bg-white tw-shadow-md tw-pt-2.5 tw-h-auto"
      >
        <div class="tw-w-full tw--mt-1.5 parent">
          <div class="child">
            <label
              class="tw-px-2 tw-font-normal tw-text-10px tw-leading-10px"
              :class="memberId !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
              >Member injured</label
            >

            <select
              id="memberId"
              v-model="memberId"
              class="tw-w-full tw-px-2 tw-pt-0 tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
              placeholder="Member injured"
              :class="[
                (submitted && memberId === undefined) || onSaveNotFilled
                  ? 'tw-placeholder-red-600 select_error tw-text-red-600'
                  : '',
                memberId !== undefined ? 'tw-font-medium' : 'tw-font-normal',
              ]"
              ref="memberId"
            >
              <option value="undefined" :disabled="true">Member injured</option>
              <option v-for="item in members" :key="item._id" :value="item._id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="tw-flex tw-justify-between tw-w-full tw-pt-7 parent">
          <div class="child tw-inline-flex">
            <label
              class="tw-flex-1 tw-px-2 tw-text-sm tw-font-normal tw-leading-4 tw-text-black tw-border-b-2 tw-h-22px"
              >Date of injury
            </label>
            <input
              id="dateOfInjury"
              type="date"
              class="tw-flex-1 tw-text-right input tw-h-22px tw-font-medium"
              :class="
                (submitted && tempDate == '') || invalidDate
                  ? ' tw-placeholder-red-600 tw-text-red-600'
                  : ''
              "
              placeholder="DD/MM/YYYY"
              :value="tempDate"
              @change="changeDateForBackend"
            />
          </div>
        </div>
        <div class="tw-flex tw-justify-between tw-w-full tw-pt-7 parent">
          <div class="child tw-inline-flex">
            <label
              class="tw-flex-1 tw-px-2 tw-text-sm tw-font-normal tw-leading-4 tw-text-black tw-border-b-2 tw-h-22px"
              >Time of injury</label
            >
            <input
              id="timeOfInjury"
              class="tw-flex-1 tw-text-right input tw-h-22px tw-font-medium"
              :class="submitted && tempTime == '' ? ' tw-placeholder-red-600 tw-text-red-600' : ''"
              placeholder="00:00 AM"
              type="time"
              :value="tempTime"
              @change="changeTimeForBackend"
            />
          </div>
        </div>
        <div class="tw-w-full tw-px-2 tw-mb-6 tw-pt-7 parent">
          <div class="child">
            <div class="tw-pb-2 tw-text-sm tw-font-normal tw-leading-4">
              Where on the body did this injury occur?
            </div>
            <div
              class="tw-text-xs tw-font-normal tw-leading-3"
              :class="{ 'error-field': submitted && natureOfInjury.length === 0 }"
              ref="bodyPart"
              id="bodyPart"
            >
              Please select body part on diagram.
            </div>
          </div>
        </div>
        <div class="tw-w-full">
          <div
            id="tabs"
            class="tw-flex tw-justify-center tw-text-xs"
            :class="{ 'error-field': submitted && natureOfInjury.length === 0 }"
          >
            <button
              class="tw-h-8 tw-py-2 tw-text-center tw-rounded-l-lg tw-w-28 hover:tw-bg-green-300 hover:tw-text-black"
              :class="{
                'tw-bg-green-700 tw-text-white': tabPosition === 'FRONT',
                'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200': tabPosition === 'BACK',
              }"
              @click="tabPosition = 'FRONT'"
            >
              Front
            </button>
            <button
              class="tw-h-8 tw-py-2 tw-text-center tw-rounded-r-lg tw-w-28 hover:tw-bg-green-300 hover:tw-text-black"
              :class="{
                'tw-bg-green-700 tw-text-white': tabPosition === 'BACK',
                'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200':
                  tabPosition === 'FRONT',
              }"
              @click="tabPosition = 'BACK'"
            >
              Back
            </button>
          </div>

          <div id="FRONT" v-if="tabPosition === 'FRONT'" class="tw-flex tw-justify-center tw-mt-6">
            <svg
              id="af086e76-5151-45da-a2e8-f4977f3f2710"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="220 60 560 1185"
              height="458px"
              width="100%"
            >
              <path
                d="M411.33,269.88c-29.28,6.37-63.48,5.56-73.34,40-14.48,50.59-5.85,115.47-5.85,115.47s26.37-9.75,37.82.43,23.76,26.94,23.76,26.94,22.9-6.22,50.7-53.35c21.95-37.22,24.42-66.89,18.37-99.51-3.22-17.39-18.37-42.71-18.37-42.71S440.6,263.52,411.33,269.88Z"
                @click="chooseBodyParts('FRONT', 'Right Shoulder')"
                :fill="isActive('FRONT', 'Right Shoulder')"
              />
              <path
                d="M588,269.88c29.27,6.37,63.48,5.56,73.34,40,14.47,50.59,5.85,115.47,5.85,115.47s-26.38-9.75-37.83.43-23.75,26.94-23.75,26.94-22.91-6.22-50.7-53.35c-22-37.22-24.42-66.89-18.38-99.51,3.23-17.39,18.38-42.71,18.38-42.71S558.73,263.52,588,269.88Z"
                @click="chooseBodyParts('FRONT', 'Left Shoulder')"
                :fill="isActive('FRONT', 'Left Shoulder')"
              />
              <path
                d="M329.87,433.43s21.29-11.38,33-3.5,25.06,25.77,25.06,25.77-7.88,11.69-9.07,32.69-2.54,45-11.1,69.71c-11.57,33.38-27.8,45.79-42.83,83.73,0,0-7.32-7.56-16.23-11.21-7.95-3.26-19.8-3.11-19.8-3.11,7.39-46.77,6.68-77.31,13.06-98.33,5.64-18.56,25.35-49.86,26.31-64.41C329.29,448.82,329.87,433.43,329.87,433.43Z"
                @click="chooseBodyParts('FRONT', 'Right Arm/Elbow')"
                :fill="isActive('FRONT', 'Right Arm/Elbow')"
              />
              <path
                d="M669.38,433.43s-21.28-11.38-33-3.5-25,25.77-25,25.77,7.87,11.69,9.06,32.69,2.55,45,11.1,69.71c11.57,33.38,27.8,45.79,42.84,83.73,0,0,7.31-7.56,16.22-11.21,7.95-3.26,19.81-3.11,19.81-3.11-7.4-46.77-6.68-77.31-13.07-98.33C691.68,510.62,672,479.32,671,464.77,670,448.82,669.38,433.43,669.38,433.43Z"
                @click="chooseBodyParts('FRONT', 'Left Arm/Elbow')"
                :fill="isActive('FRONT', 'Left Arm/Elbow')"
              />
              <path
                d="M396.2,587.39s43.56,37.74,34.19,85.43c-10.22,52-51.74,88.78-51.74,88.78s-10.13-56.93-7.48-83.05C376.74,623.67,396.2,587.39,396.2,587.39Z"
                @click="chooseBodyParts('FRONT', 'Right Hip')"
                :fill="isActive('FRONT', 'Right Hip')"
              />
              <path
                d="M602.88,587.39s-43.57,37.74-34.2,85.43c10.22,52,51.74,88.78,51.74,88.78s10.13-56.93,7.48-83.05C622.33,623.67,602.88,587.39,602.88,587.39Z"
                @click="chooseBodyParts('FRONT', 'Left Hip')"
                :fill="isActive('FRONT', 'Left Hip')"
              />
              <path
                d="M378.15,766.87l17.5,101.5,4.6,56.64A47.1,47.1,0,0,1,435,910.16c20.81,0,35.4,17.08,35.4,17.08L491.8,763.16s-22.65-28.74-57.09-28.74C405.83,734.42,378.15,766.87,378.15,766.87Z"
                @click="chooseBodyParts('FRONT', 'Right Upper Leg')"
                :fill="isActive('FRONT', 'Right Upper Leg')"
              />
              <path
                d="M621.18,766.87l-17.5,101.5L599.09,925a47.1,47.1,0,0,0-34.73-14.85c-20.81,0-35.41,17.08-35.41,17.08L507.53,763.16s22.65-28.74,57.09-28.74C593.5,734.42,621.18,766.87,621.18,766.87Z"
                @click="chooseBodyParts('FRONT', 'Left Upper Leg')"
                :fill="isActive('FRONT', 'Left Upper Leg')"
              />
              <path
                d="M402.69,931.05s13.52-14.31,33.44-14.31c16.83,0,32.42,17.18,32.42,17.18l-4.29,30.54s-10.84,12.06-30.55,11.14c-13.62-.64-32.31-18.3-32.31-18.3L403.65,943Z"
                @click="chooseBodyParts('FRONT', 'Right Knee')"
                :fill="isActive('FRONT', 'Right Knee')"
              />
              <path
                d="M596.64,931.05s-13.52-14.31-33.43-14.31c-16.84,0-32.43,17.18-32.43,17.18l4.3,30.54s10.81,11.14,30.54,11.14c12.89,0,32.32-18.3,32.32-18.3L595.69,943Z"
                @click="chooseBodyParts('FRONT', 'Left Knee')"
                :fill="isActive('FRONT', 'Left Knee')"
              />
              <path
                d="M398.42,963.51s14.17,18,33.9,19.15c16.68.94,31.1-7.64,31.1-7.64s8.22,37.17,4.78,68.19-5.66,42.16,0,87.34c0,0-9,3.5-24.43,2-8.86-.86-20-9.49-21.32-13.62-9.35-30.39-28.32-86-28.32-114.39C394.13,975.44,398.42,963.51,398.42,963.51Z"
                @click="chooseBodyParts('FRONT', 'Right Lower Leg')"
                :fill="isActive('FRONT', 'Right Lower Leg')"
              />
              <path
                d="M600.91,963.51s-14.17,18-33.89,19.15c-16.68.94-31.11-7.64-31.11-7.64s-8.22,37.17-4.78,68.19,5.67,42.16,0,87.34c0,0,9,3.5,24.43,2,8.87-.86,20.06-9.49,21.33-13.62,9.35-30.39,28.32-86,28.32-114.39C605.21,975.44,600.91,963.51,600.91,963.51Z"
                @click="chooseBodyParts('FRONT', 'Left Lower Leg')"
                :fill="isActive('FRONT', 'Left Lower Leg')"
              />
              <path
                d="M469.36,1137.39s8.43,49,10.34,54.73,11.73,30.54,10.4,34.84-6.41,7.16-13.57,6.68-20.54,1.27-20.54,1.27l-26.11-5.57s-13.66,1-13.66-9.54,11.46-37.23,11.46-37.23,3.66-22.75,2.2-34.84a135.25,135.25,0,0,0-2.68-14.8s12.25,7.64,22.42,7.85A53.48,53.48,0,0,0,469.36,1137.39Z"
                @click="chooseBodyParts('FRONT', 'Right Ankle/Foot')"
                :fill="isActive('FRONT', 'Right Ankle/Foot')"
              />
              <path
                d="M530,1137.39s-8.44,49-10.34,54.73-11.74,30.54-10.4,34.84,6.4,7.16,13.56,6.68,20.54,1.27,20.54,1.27l26.11-5.57s13.66,1,13.66-9.54-11.45-37.23-11.45-37.23-3.66-22.75-2.21-34.84a135.25,135.25,0,0,1,2.68-14.8s-12.25,7.64-22.42,7.85A53.46,53.46,0,0,1,530,1137.39Z"
                @click="chooseBodyParts('FRONT', 'Left Ankle/Foot')"
                :fill="isActive('FRONT', 'Left Ankle/Foot')"
              />
              <path
                d="M287.16,633.71a39.16,39.16,0,0,1,19.95,3.35A38.24,38.24,0,0,1,322.23,650l-3.34,50.58s3.26,45.28-1.44,45.82c-6.2.72-11.69-32-11.69-32s-.95,46.77-6.92,46.77c-5.25,0-9.78-48.68-9.78-48.68s-6.45,50.11-11.54,48.68c-5.78-1.63-2.3-49.64-2.3-49.64s-17.66,37.23-22.67,34.6c-4.73-2.47,13.6-55.84,13.6-55.84S248,711,241.89,705.47s14.41-37.38,14.41-37.38Z"
                @click="chooseBodyParts('FRONT', 'Right Wrist/Hand')"
                :fill="isActive('FRONT', 'Right Wrist/Hand')"
              />
              <path
                d="M712.17,633.71a39.16,39.16,0,0,0-19.95,3.35A38.25,38.25,0,0,0,677.11,650l3.34,50.58s-3.27,45.28,1.43,45.82c6.2.72,11.69-32,11.69-32s1,46.77,6.92,46.77c5.25,0,9.79-48.68,9.79-48.68s6.44,50.11,11.53,48.68c5.78-1.63,2.31-49.64,2.31-49.64s17.66,37.23,22.67,34.6c4.72-2.47-13.61-55.84-13.61-55.84s18.14,20.76,24.27,15.2S743,668.09,743,668.09Z"
                @click="chooseBodyParts('FRONT', 'Left Wrist/Hand')"
                :fill="isActive('FRONT', 'Left Wrist/Hand')"
              />
              <path
                d="M598.86,583l6.27-123.69c-24.57-10.72-56.78-42.48-71.15-96.81-18-68.21,16-105.31,16-105.31s-35.72,20.36-50.35,20.36-50.35-20.36-50.35-20.36,34.07,37.1,16,105.31C451,416.8,418.77,448.56,394.2,459.28L400.48,583s32.8,18.32,38,67.16c2.58,23.94-6.24,45.31-10.69,54.22s-18.14,30.07-18.14,30.07,13.13-6.68,38.42-3.82c23.05,2.61,44.74,22.27,44.74,22.27V742.06l6.81.24,6.8-.24v10.81s21.7-19.66,44.74-22.27c25.3-2.86,38.42,3.82,38.42,3.82S576,713.26,571.49,704.35s-13.26-30.28-10.69-54.22C566.05,601.29,598.86,583,598.86,583Z"
                @click="chooseBodyParts('FRONT', 'Chest/Abdomen')"
                :fill="isActive('FRONT', 'Chest/Abdomen')"
              />
              <path
                d="M447.09,250.79s4.13-13-2.55-17.81c-5.4-3.87-19.72,0-19.72,0s-15.91,2.54-21.32-3.19l-5.6-17.5L394.2,204V185.89s-14.57-2.55-13.93-5.1,13.93-22.9,13.93-22.9,1.84-7,0-12.73-7-16.4-6.29-22.27c6.29-55.37,53.52-55.12,79.86-56.32,49-2.23,87.82,26.09,81.45,86.54-1.51,14.41-18.49,29.7-16.86,39.78,3.5,21.63,19,57.9,19,57.9s-29.49,20.37-51.66,20.37S447.09,250.79,447.09,250.79Z"
                @click="chooseBodyParts('FRONT', 'Head/Face/Neck')"
                :fill="isActive('FRONT', 'Head/Face/Neck')"
              />
            </svg>
          </div>

          <div
            id="BACK"
            v-else-if="tabPosition === 'BACK'"
            class="tw-flex tw-justify-center tw-mt-6"
          >
            <svg
              id="b893dbae-14b8-486b-ac29-384470045217"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="220 60 560 1185"
              height="458px"
              width="100%"
            >
              <path
                id="head"
                d="M290.06,665.66A33.31,33.31,0,0,0,273,652.78c-10.61-3.51-16.72.19-16.72.19l-19.4,64s-19,41.23-14.8,43.39c5.55,2.85,22.21-25.81,22.21-25.81s-15.59,44.11-10,46.21c4.91,1.85,26.3-42.11,26.3-42.11s-11.62,49.17-6.35,49.62c6,.52,19.64-45.64,19.64-45.64s3.42,41.06,9,40.37c5.3-.65,6.94-57,6.94-57s9.66,25.82,17.36,22.76-.33-40-.33-40Z"
                @click="chooseBodyParts('BACK', 'Left Wrist/Hand')"
                :fill="isActive('BACK', 'Left Wrist/Hand')"
              />
              <path
                d="M638.05,665.66a33.31,33.31,0,0,1,17.11-12.88c10.6-3.51,16.72.19,16.72.19l19.4,64s19,41.23,14.8,43.39c-5.56,2.85-22.21-25.81-22.21-25.81s15.58,44.11,10,46.21c-4.91,1.85-26.31-42.11-26.31-42.11s11.63,49.17,6.36,49.62c-6,.52-19.65-45.64-19.65-45.64s-3.41,41.06-9,40.37c-5.3-.65-6.94-57-6.94-57s-9.66,25.82-17.36,22.76.32-40,.32-40Z"
                @click="chooseBodyParts('BACK', 'Right Wrist/Hand')"
                :fill="isActive('BACK', 'Right Wrist/Hand')"
              />
              <path
                d="M516.57,247.79s-4.13-10,2.55-14.81c5.4-3.87,19.72,0,19.72,0s15.91,2.54,21.32-3.19l5.6-17.5,3.7-8.27V185.89s14.57-2.55,13.93-5.1-13.93-22.9-13.93-22.9-1.84-7,0-12.73,7-16.4,6.29-22.27c-6.29-55.37-53.52-55.12-79.86-56.32-49-2.23-87.82,26.09-81.45,86.54,1.51,14.41,18.49,29.7,16.86,39.78-3.5,21.63-19,54.9-19,54.9s29.49,20.37,51.66,20.37S516.57,247.79,516.57,247.79Z"
                @click="chooseBodyParts('BACK', 'Head/Face/Neck')"
                :fill="isActive('BACK', 'Head/Face/Neck')"
              />
              <path
                d="M592.08,566.67c11.29,32.58,27.84,55.37,42.51,92.39,0,0,7.14-7.38,15.83-10.95,7.76-3.18,19.33-3,19.33-3-7.22-45.64-5.83-70.26-12.06-90.76a54.54,54.54,0,0,1-29.62,13C611.46,569,592.08,566.67,592.08,566.67Z"
                @click="chooseBodyParts('BACK', 'Right Lower Arm')"
                :fill="isActive('BACK', 'Right Lower Arm')"
              />
              <path
                d="M639.71,503.19c-11.29-32.57-14.84-49-14.37-66.24,0,0,11.91-91.15-6.27-130.73-21.27-46.3-52-29.8-52-29.8,36.2,90.8,4.66,183.93,4.66,183.93s.46,19.09,11,53.42a54.48,54.48,0,0,1,29.62-13C629,499.09,639.71,503.19,639.71,503.19Z"
                @click="chooseBodyParts('BACK', 'Right Upper Arm/Shoulder')"
                :fill="isActive('BACK', 'Right Upper Arm/Shoulder')"
              />
              <path
                d="M335.38,566.67c-11.29,32.58-27.84,55.37-42.51,92.39,0,0-7.14-7.38-15.83-10.95-7.76-3.18-19.32-3-19.32-3,7.21-45.64,5.83-70.26,12-90.76a54.59,54.59,0,0,0,29.62,13C316,569,335.38,566.67,335.38,566.67Z"
                @click="chooseBodyParts('BACK', 'Left Lower Arm')"
                :fill="isActive('BACK', 'Left Lower Arm')"
              />
              <path
                d="M611.28,507.5c22.38-3.53,35.26,6.21,35.26,6.21l9.16,33.41s-8.53,9.22-28.87,13.35c-17.84,3.61-39.1-6.14-39.1-6.14l-5.29-34.53S592.09,510.53,611.28,507.5Z"
                @click="chooseBodyParts('BACK', 'Right Elbow')"
                :fill="isActive('BACK', 'Right Elbow')"
              />
              <path
                d="M287.84,503.19c11.29-32.57,14.84-49,14.37-66.24,0,0-11.91-91.15,6.27-130.73,21.27-46.3,52-29.8,52-29.8-36.2,90.8-4.66,183.93-4.66,183.93s-.46,19.09-11,53.42a54.53,54.53,0,0,0-29.62-13C298.6,499.09,287.84,503.19,287.84,503.19Z"
                @click="chooseBodyParts('BACK', 'Left Upper Arm/Shoulder')"
                :fill="isActive('BACK', 'Left Upper Arm/Shoulder')"
              />
              <path
                d="M316.26,507.5C293.89,504,281,513.71,281,513.71l-9.15,33.41s8.53,9.22,28.87,13.35c17.84,3.61,39.1-6.14,39.1-6.14l5.29-34.53S335.46,510.53,316.26,507.5Z"
                @click="chooseBodyParts('BACK', 'Left Elbow')"
                :fill="isActive('BACK', 'Left Elbow')"
              />
              <path
                d="M589.11,740.35l-20.18,137-11.64,78.94s-4.26-3.43-26.15-2.33c-22.13,1.12-31.23,10.29-31.23,10.29L473.94,841l-4.71-81.07c7.92,4.19,35,16.35,56.86,14.2C554.13,771.4,589.11,740.35,589.11,740.35Z"
                @click="chooseBodyParts('BACK', 'Right Upper Leg')"
                :fill="isActive('BACK', 'Right Upper Leg')"
              />
              <path
                d="M338.81,740.35l20.18,137,11.64,78.94s4.26-3.43,26.15-2.33c22.13,1.12,31.23,10.29,31.23,10.29L454,841l4.71-81.07c-7.92,4.19-35,16.35-56.86,14.2C373.79,771.4,338.81,740.35,338.81,740.35Z"
                @click="chooseBodyParts('BACK', 'Left Upper Leg')"
                :fill="isActive('BACK', 'Left Upper Leg')"
              />
              <path
                d="M501.1,969.76s12.63-8,32-9.52c18-1.43,25.15,2.72,25.15,2.72l10.31,41c-5.26,4.52-21.94,8.21-41.19,8.21-12.57,0-26.73-10.94-26.73-10.94L502,979.4Z"
                @click="chooseBodyParts('BACK', 'Right Knee')"
                :fill="isActive('BACK', 'Right Knee')"
              />
              <path
                d="M427,969.76s-12.63-8-32-9.52c-18-1.43-25.15,2.72-25.15,2.72l-10.31,41c5.26,4.52,21.94,8.21,41.19,8.21,12.57,0,26.73-10.94,26.73-10.94l-1.4-21.88Z"
                @click="chooseBodyParts('BACK', 'Left Knee')"
                :fill="isActive('BACK', 'Left Knee')"
              />
              <path
                d="M569.56,1011.8s-20.32,7.31-39.56,8.39c-16.28.92-32.15-12.32-32.15-12.32s-7.22,49.14-3.87,79.4,5.53,33.14,0,77.22c0,0,7.79,4.41,22.84,3,8.65-.84,20.56-10.26,21.81-14.29,9.12-29.65,24.48-76.08,27.63-103.6C568.56,1029.38,569.56,1011.8,569.56,1011.8Z"
                @click="chooseBodyParts('BACK', 'Right Lower Leg')"
                :fill="isActive('BACK', 'Right Lower Leg')"
              />
              <path
                d="M358.55,1011.8s20.31,7.31,39.56,8.39c16.28.92,32.15-12.32,32.15-12.32s7.22,49.14,3.86,79.4-5.52,33.14,0,77.22c0,0-7.78,4.41-22.83,3-8.65-.84-20.57-10.26-21.81-14.29-9.12-29.65-24.49-76.08-27.63-103.6C359.55,1029.38,358.55,1011.8,358.55,1011.8Z"
                @click="chooseBodyParts('BACK', 'Left Lower Leg')"
                :fill="isActive('BACK', 'Left Lower Leg')"
              />
              <path
                d="M493.32,1169.41s-2.69,26.45-6.25,40.66c-2.55,10.18-10.36,22.54,6.38,23.75,14.57,1.06,47.63,2.73,47.63-2.79,0-10.25-10.66-39.74-9.25-51.53a131.89,131.89,0,0,1,2.62-14.45s-12,7.46-21.88,7.66A52.11,52.11,0,0,1,493.32,1169.41Z"
                @click="chooseBodyParts('BACK', 'Right Ankle/Foot')"
                :fill="isActive('BACK', 'Right Ankle/Foot')"
              />
              <path
                d="M434.79,1169.41s2.69,26.45,6.25,40.66c2.55,10.18,10.36,22.54-6.38,23.75-14.57,1.06-47.64,2.73-47.64-2.79,0-10.25,10.67-39.74,9.26-51.53a134.74,134.74,0,0,0-2.62-14.45s11.95,7.46,21.87,7.66A52.14,52.14,0,0,0,434.79,1169.41Z"
                @click="chooseBodyParts('BACK', 'Left Ankle/Foot')"
                :fill="isActive('BACK', 'Left Ankle/Foot')"
              />
              <polygon
                points="361.67 461.75 364.98 591.66 563.35 591.66 566.65 461.75 361.67 461.75"
                @click="chooseBodyParts('BACK', 'Lower Back')"
                :fill="isActive('BACK', 'Lower Back')"
              />
              <path
                d="M566.65,597.41h-205s-25.43,41-22,133.79c0,0,39.15,36.36,62.71,36.51,32.91.2,61.81-17,61.81-17s28.91,17.15,61.82,17c23.56-.15,62.71-36.51,62.71-36.51C592.08,638.38,566.65,597.41,566.65,597.41Z"
                @click="chooseBodyParts('BACK', 'Hip')"
                :fill="isActive('BACK', 'Hip')"
              />
              <path
                d="M561.28,275.88s-33.39-28.52-44-22.28C501.1,263.07,478.34,273,464.16,273s-36.94-9.91-53.08-19.38c-10.64-6.24-44,22.28-44,22.28-38.49,100-5.38,181.1-5.38,181.1h205S599.77,375.9,561.28,275.88Z"
                @click="chooseBodyParts('BACK', 'Upper Back')"
                :fill="isActive('BACK', 'Upper Back')"
              />
            </svg>
          </div>
        </div>

        <div class="tw-w-full tw--mt-1" v-for="(item, index) in natureOfInjury" :key="index">
          <div class="parent">
            <div class="child">
              <label
                class="tw-text-10px tw-leading-10px tw-px-2 tw-text-black tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
                >Body part</label
              >
              <input
                :id="`bodyPart${index}`"
                class="input tw-px-2 tw-pb-2 tw-font-medium"
                disabled
                placeholder="Body part"
                :value="item.bodyArea + ' : ' + item.bodyPart"
              />
            </div>
          </div>
          <div :prop="'natureOfInjury.' + index + '.injury'" :rules="rules.injury" class="parent">
            <div class="child">
              <label
                class="tw-text-10px tw-leading-10px tw-px-2 tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
                :class="item.injury ? 'tw-text-gray-1020' : 'tw-text-white'"
                >What was the nature of the injury?</label
              >
              <select
                :id="`natureOfInjury.${index}.injury`"
                class="tw-w-full tw-px-2 tw-pt-0 tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
                v-model="item.injury"
                :class="[
                  {
                    ' tw-placeholder-red-600 select_error tw-text-red-600':
                      (submitted && item.injury === undefined) ||
                      (onSaveNotFilled && item.injury === undefined),
                  },
                  item.injury !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
                :ref="`natureOfInjury.${index}.injury`"
              >
                <option value="undefined" :disabled="true">
                  What was the nature of the injury?
                </option>
                <option v-for="item in injuryNatureList" :key="item.option" :value="item.value">
                  {{ item.option }}
                </option>
              </select>
            </div>
          </div>
          <Transition name="other">
            <div class="tw-w-full parent" v-show="item.injury === 'Other'">
              <div class="child">
                <input
                  :id="`natureOfInjury.${index}.injuryOther`"
                  :ref="`natureOfInjury.${index}.injuryOther`"
                  class="input tw-pt-2.5 tw-px-2 tw-pb-2"
                  :class="[
                    {
                      ' tw-placeholder-red-600  ':
                        (submitted && item.injuryOther === undefined) ||
                        (onSaveNotFilled && item.injuryOther === undefined),
                    },
                    item.injuryOther
                      ? 'tw-font-medium tw-text-black'
                      : 'tw-font-normal tw-text-gray-1010',
                  ]"
                  autocomplete="off"
                  v-model="item.injuryOther"
                  placeholder="Please describe the nature of injury"
                />
              </div></div
          ></Transition>
        </div>

        <div class="tw-w-full parent">
          <div class="child">
            <label
              id="howPlayerInjured"
              ref="howPlayerInjured"
              class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
              :class="howPlayerInjured !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
              >How was the player injured?</label
            >

            <select
              id="howPlayerInjured"
              class="tw-w-full tw-px-2 tw-pt-0 tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
              v-model="howPlayerInjured"
              placeholder="How was the player injured?"
              :class="[
                {
                  ' tw-placeholder-red-600 select_error tw-text-red-600':
                    submitted && howPlayerInjured === undefined,
                },
                howPlayerInjured !== undefined ? 'tw-font-medium' : 'tw-font-normal',
              ]"
            >
              <option value="undefined" :disabled="true">How was the player injured?</option>
              <option v-for="item in howPlayerInjuredList" :key="item.option" :value="item.value">
                {{ item.option }}
              </option>
            </select>
          </div>
        </div>
        <Transition name="other">
          <div class="tw-w-full parent" v-show="howPlayerInjured === 'Other'">
            <div class="child">
              <input
                id="howPlayerInjuredOther"
                ref="howPlayerInjuredOther"
                class="input tw-pt-2.5 tw-px-2 tw-pb-2"
                :class="[
                  {
                    ' tw-placeholder-red-600  ': submitted && !howPlayerInjuredOther,
                  },
                  howPlayerInjuredOther
                    ? 'tw-font-medium tw-text-black'
                    : 'tw-font-normal tw-text-gray-1010',
                ]"
                autocomplete="off"
                v-model="howPlayerInjuredOther"
                placeholder="Please describe how the player was injured"
              />
            </div></div
        ></Transition>
        <div class="tw-w-full parent" v-if="headIsExits">
          <div class="child">
            <label
              id="symptons"
              ref="symptons"
              class="tw-text-sm tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4 tw-flex tw-justify-between"
              :class="{
                ' tw-text-red-600  ': submitted && symptons === undefined,
              }"
              >Were there signs or symptoms of a concussion?</label
            >

            <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
              <div v-for="(element, index) in yesOrNo" :key="index" class="tw-flex tw-items-center">
                <input type="radio" v-model="symptons" :value="element.value" />
                <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                  >{{ element.option }}
                </span>
              </div>
            </label>
          </div>
        </div>

        <!-- Concussion Questions -->
        <div class="tw-w-full" v-if="symptons && headIsExits">
          <p class="text tw-font-medium tw-px-2 tw-pt-8 tw-text-sm tw-leading-5">
            You have identified that signs/symptoms of concussion are present, you will now be
            guided through a series of questions to help you record the signs and symptoms and
            manage the injury.
          </p>

          <!-- Q1 -->

          <label
            id="clinicalFeatures"
            ref="clinicalFeatures"
            class="tw-flex tw-justify-between tw-text-sm tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && clinicalFeatures === undefined,
            }"
            >Are there clinical features of a potentially serious or structural head and/or neck
            injury, including prolonged loss of consciousness (>1 minute) requiring urgent and
            emergency hospital transfer?</label
          >
          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div v-for="(element, index) in yesOrNo" :key="index" class="tw-flex tw-items-center">
              <input type="radio" v-model="clinicalFeatures" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <p
            v-if="clinicalFeatures"
            class="text tw-px-2 tw-pt-8 tw-text-sm tw-font-medium tw-leading-5 tw-text-red-1000"
          >
            Do not remove the player from the field of play. An ambulance should be called
            immediately! Please complete the following questions, you can save them and do them
            later if needed.
          </p>

          <p
            class="text tw-px-2 tw-pt-8 tw-text-sm tw-font-medium tw-leading-5"
            :class="{
              'tw-text-red-600 tw-font-medium ': submitted && lossOfConsciousness === undefined,
            }"
          >
            Did you, or anyone else including coaches, referees, parents or other players observe
            any of the following:
          </p>
          <!-- Q2.1 -->
          <label
            id="lossOfConsciousness"
            ref="lossOfConsciousness"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && lossOfConsciousness === undefined,
            }"
            >Loss of consciousness (or prolonged loss of movement >1-2 seconds) or not responding
            appropriately to trainers, referees or other players</label
          >

          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="lossOfConsciousness" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <!--Q2.2  -->
          <label
            id="protectiveAction"
            ref="protectiveAction"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && protectiveAction === undefined,
            }"
            >No protective action in fall to the ground (not bracing for impact/floppy or
            stiff)</label
          >

          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="protectiveAction" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <!--Q2.3  -->
          <label
            id="impact"
            ref="impact"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && impact === undefined,
            }"
            >Impact seizure/convulsion/fit (stiffening or shaking of arms and/or legs on
            impact)</label
          >

          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="impact" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <!--Q2.4  -->
          <label
            id="balanceDisturbance"
            ref="balanceDisturbance"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && balanceDisturbance === undefined,
            }"
            >Balance disturbance (unable to stand steadily or walk unassisted) or clumsy or slow to
            get up following a possible head injury (10-15 seconds)</label
          >

          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="balanceDisturbance" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <!--Q2.5  -->
          <label
            id="dazedOrBlank"
            ref="dazedOrBlank"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && dazedOrBlank === undefined,
            }"
            >Dazed or blank/vacant stare or not their normal selves/not reacting appropriately to
            surroundings.</label
          >

          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="dazedOrBlank" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <!--Q2.6  -->
          <label
            id="unusualBehaviour"
            ref="unusualBehaviour"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && unusualBehaviour === undefined,
            }"
            >Unusual behaviour for the player</label
          >
          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="unusualBehaviour" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <!--Q2.7  -->
          <label
            id="confusion"
            ref="confusion"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && confusion === undefined,
            }"
          >
            Confusion or disorientation
          </label>

          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="confusion" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <!--Q2.8  -->
          <label
            id="memoryImpairment"
            ref="memoryImpairment"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && memoryImpairment === undefined,
            }"
            >Memory impairment (e.g. fails Awareness Questions symptoms - refer to CRT6)</label
          >

          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="memoryImpairment" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <!--Q2.9  -->
          <label
            id="playerReports"
            ref="playerReports"
            class="tw-text-sm tw-flex tw-justify-between tw-px-2 tw-leading-5 tw-text-black tw-font-normal tw-pt-4"
            :class="{
              'tw-text-red-600 ': submitted && playerReports === undefined,
            }"
            >Player reports or displays any other concussion symptoms (refer to CRT6)</label
          >

          <label class="tw-font-normal tw-grid tw-grid-cols-3 tw-px-2 tw-pb-2 tw-pt-4 input">
            <div
              v-for="(element, index) in yesNoOptions"
              :key="index"
              class="tw-flex tw-items-center"
            >
              <input type="radio" v-model="playerReports" :value="element.value" />
              <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3"
                >{{ element.option }}
              </span>
            </div>
          </label>

          <p
            v-if="
              lossOfConsciousness ||
              protectiveAction ||
              impact ||
              balanceDisturbance ||
              dazedOrBlank ||
              unusualBehaviour ||
              confusion ||
              memoryImpairment ||
              playerReports
            "
            class="text tw-px-2 tw-pt-8 tw-pb-4 tw-text-red-1000 tw-text-sm tw-font-medium tw-leading-5"
          >
            The player must be immediately removed from the field and should not return to play in
            the same game, or any game, until medically cleared to play by a doctor even if they
            appear to have recovered. Please complete the following questions, you can save them and
            complete them later if needed.
          </p>
        </div>

        <div v-else>
          <div class="tw-w-full parent">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
                :class="playerRemoveBy !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
                >How was the player removed from the field?</label
              >

              <select
                id="playerRemoveBy"
                ref="playerRemoveBy"
                class="tw-w-full tw-px-2 tw-pt-0 tw-whitespace-pre-wrap tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
                v-model="playerRemoveBy"
                placeholder="How was the player removed from the field?"
                :class="[
                  {
                    ' tw-placeholder-red-600 select_error tw-text-red-600':
                      submitted && playerRemoveBy === undefined,
                  },
                  playerRemoveBy !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
              >
                <option value="undefined" :disabled="true">
                  How was the player removed from the field?
                </option>
                <option v-for="item in playerRemoveList" :key="item.option" :value="item.value">
                  {{ item.option }}
                </option>
              </select>
            </div>
          </div>
          <div class="tw-w-full parent">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-flex-wrap tw-mb-2.5"
                :class="treatPlayer !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
                >Was an ambulance or doctor called to treat the player?</label
              >

              <select
                id="treatPlayer"
                ref="treatPlayer"
                class="tw-flex tw-w-full tw-px-2 tw-whitespace-pre-wrap tw-pt-0 tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
                v-model="treatPlayer"
                placeholder=""
                :class="[
                  {
                    ' tw-placeholder-red-600 select_error tw-text-red-600':
                      submitted && treatPlayer === undefined,
                  },
                  treatPlayer !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
                @change="playerReferredTo = undefined"
              >
                <option value="undefined" :disabled="true" style="word-wrap: break-word">
                  Was an ambulance or doctor called to treat the player?
                </option>
                <option v-for="item in yesOrNo" :key="item.option" :value="item.value">
                  {{ item.option }}
                </option>
              </select>
            </div>
          </div>
          <div class="tw-w-full parent" v-show="treatPlayer === true">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
                :class="playerReferredTo !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
                >Who was the player referred to?</label
              >

              <select
                id="playerReferredTo"
                ref="playerReferredTo"
                class="tw-w-full tw-px-2 tw-pt-0 tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
                v-model="playerReferredTo"
                :class="[
                  {
                    ' tw-placeholder-red-600 select_error tw-text-red-600':
                      submitted && playerReferredTo === undefined,
                  },
                  playerReferredTo !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
                placeholder=""
              >
                <option value="undefined" :disabled="true">Who was the player referred to?</option>
                <option v-for="item in playerRefferedList" :key="item.option" :value="item.value">
                  {{ item.option }}
                </option>
              </select>
            </div>
          </div>
          <Transition name="other">
            <div class="tw-w-full parent" v-show="playerReferredTo === 'Other'">
              <div class="child">
                <input
                  id="playerReferredToOther"
                  class="input tw-px-2 tw-pb-2 tw-pt-2.5"
                  :class="[
                    {
                      ' tw-placeholder-red-600': submitted && !playerReferredToOther,
                    },
                    playerReferredToOther
                      ? 'tw-font-medium tw-text-black'
                      : 'tw-font-normal tw-text-gray-1010',
                  ]"
                  autocomplete="off"
                  v-model="playerReferredToOther"
                  placeholder="Please describe who the player was referred to"
                />
              </div>
            </div>
          </Transition>
          <div class="tw-w-full parent">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
                :class="immediateCare !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
                >What was the immediate care applied to the injury?</label
              >

              <select
                id="immediateCare"
                class="tw-w-full tw-px-2 tw-pt-0 tw-whitespace-pre-wrap tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
                v-model="immediateCare"
                :class="[
                  {
                    ' tw-placeholder-red-600 select_error tw-text-red-600':
                      submitted && immediateCare === undefined,
                  },
                  immediateCare !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
                placeholder=""
              >
                <option value="undefined" :disabled="true">
                  What was the immediate care applied to the injury?
                </option>
                <option v-for="item in immediateCareList" :key="item.option" :value="item.value">
                  {{ item.option }}
                </option>
              </select>
            </div>
          </div>

          <Transition name="other">
            <div class="tw-w-full parent" v-show="immediateCare === 'Other'">
              <div class="child">
                <input
                  id="immediateCareOther"
                  class="input tw-pt-2.5 tw-px-2 tw-pb-2"
                  :class="[
                    { ' tw-placeholder-red-600 ': submitted && !immediateCareOther },
                    immediateCareOther
                      ? 'tw-font-medium tw-text-black'
                      : 'tw-font-normal tw-text-gray-1010',
                  ]"
                  autocomplete="off"
                  v-model="immediateCareOther"
                  placeholder="Please describe the treatment"
                />
              </div>
            </div>
          </Transition>
          <div class="tw-w-full tw-mb-0">
            <label
              class="tw-flex tw-justify-between tw-px-2 tw-pb-2 tw-text-sm tw-font-normal tw-leading-4 tw-text-black tw-pt-4"
              :class="submitted && firstResponderName === '' ? 'tw-text-red-600' : 'tw-text-black'"
              >First Responder Name</label
            >
            <textarea
              id="firstResponderName"
              v-model="firstResponderName"
              class="textBox tw-p-2"
              maxlength="50"
              :class="firstResponderName !== '' ? 'tw-font-medium' : 'tw-font-normal'"
            ></textarea>
          </div>
          <div class="tw-w-full parent tw--mt-2">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
                :class="firstResponderRole !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
                >First responder Role</label
              >

              <select
                id="firstResponderRole"
                class="tw-w-full tw-px-2 tw-pt-0 tw-whitespace-pre-wrap tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
                v-model="firstResponderRole"
                :class="[
                  {
                    ' tw-placeholder-red-600 select_error tw-text-red-600':
                      submitted && firstResponderRole === undefined,
                  },
                  firstResponderRole !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
                placeholder=""
              >
                <option value="undefined" :disabled="true">First responder Role</option>
                <option
                  v-for="item in firstResponderRoleList"
                  :key="item.option"
                  :value="item.value"
                >
                  {{ item.option }}
                </option>
              </select>
            </div>
          </div>
          <div class="tw-w-full">
            <label
              class="tw-flex tw-justify-between tw-px-2 tw-pb-2 tw-text-sm tw-font-normal tw-leading-4 tw-text-black tw-pt-7"
              >Any significant observations.</label
            >

            <textarea
              id="otherSignificants"
              class="tw-h-20 textBox tw-p-4 tw-pt-2.5 tw-mb-3"
              v-model="otherSignificants"
              resize="none"
              rows="4"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="tw-mt-8 sm:tw-flex sm:tw-justify-center" v-if="headIsExits && symptons === true">
        <!-- All concussion questions are answered -->
        <!-- <button
          v-if="
            clinicalFeatures !== undefined &&
              lossOfConsciousness !== undefined &&
              protectiveAction !== undefined &&
              impact !== undefined &&
              balanceDisturbance !== undefined &&
              dazedOrBlank !== undefined &&
              unusualBehaviour !== undefined &&
              memoryImpairment !== undefined &&
              playerReports !== undefined
          "
          class=" tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 sm:tw-max-w-xs hover:tw-bg-green-300 hover:tw-text-black"
          type="success"
          size="medium"
          @click="moveTosymptomsOrTreatment"
        >
          {{ buttonName }}
        </button> -->
        <button
          class="tw-justify-center tw-w-full tw-mb-4 sm:tw-mr-4 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 sm:tw-max-w-xs hover:tw-bg-green-300 hover:tw-text-black"
          type="success"
          size="medium"
          :disabled="isSavingSymptoms"
          @click="moveTosymptomsOrTreatment"
        >
          Continue to Symptoms
        </button>
        <button
          class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-none tw-border-2 tw-border-green-700 hover:tw-border-green-300 hover:tw-text-black sm:tw-w-72"
          type=""
          size="medium"
          :disabled="isSavingDraft"
          @click="saveLater"
        >
          Save Draft
        </button>
      </div>
      <div class="tw-mt-8 sm:tw-flex sm:tw-justify-center" v-else>
        <button
          class="tw-justify-center tw-w-full tw-mb-4 sm:tw-mr-4 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 sm:tw-max-w-xs hover:tw-bg-green-300 hover:tw-text-black"
          type="success"
          size="medium"
          :disabled="isSaving"
          @click="onNextStep"
        >
          Complete
        </button>
        <button
          class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-none tw-border-2 tw-border-green-700 hover:tw-border-green-300 hover:tw-text-black sm:tw-w-72"
          type=""
          size="medium"
          :disabled="isSavingDraft"
          @click="saveLater"
        >
          Save Draft
        </button>
      </div>
    </div>
  </div>
  <div v-else-if="symptomRecordStep === true && treatmentStep === false">
    <symptom-record :injury="injury" @treatment="goToTreatmentStep" />
  </div>
  <div v-else-if="symptomRecordStep === false && treatmentStep === true">
    <treatment :injury="injury" :members="members" @redirectFromTreatment="saveInjuryData" />
  </div>
</template>
<script>
import _ from "lodash";
import dayjs from "@/utils/dayjs";
import {
  errormsg,
  roles,
  injuryNatureList,
  playerRemoveList,
  howPlayerInjuredList,
  playerRefferedList,
  immediateCareList,
  firstResponderRoleList,
  yesOrNo,
  yesNoOptions,
} from "../../utils/constants";

import symptomRecord from "./symptomRecord.vue";
import Treatment from "./Treatment.vue";

let timer;

export default {
  components: { symptomRecord, Treatment },
  props: ["injury"],
  data() {
    return {
      rules: {
        "member._id": {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
        },
        dateOfInjury: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
        },
        timeOfInjury: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
        },
        symptons: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        injury: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        injuryOther: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.injury.natureOfInjury.injury === "Other" && !value)
              return callback(new Error(errormsg.input_option));
            return callback();
          },
        },
        playerRemoveBy: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        treatPlayer: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        playerReferredTo: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.injury.treatPlayer === true && !value)
              return callback(new Error(errormsg.input_option));
            return callback();
          },
        },
        playerReferredToOther: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.injury.playerReferredTo === "Other" && !value)
              return callback(new Error(errormsg.input_option));
            return callback();
          },
        },
        immediateCare: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        immediateCareOther: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.injury.immediateCare === "Other" && !value)
              return callback(new Error(errormsg.input_option));
            return callback();
          },
        },
      },
      injuryNatureList,
      howPlayerInjuredList,
      playerRemoveList,
      playerRefferedList,
      immediateCareList,
      firstResponderRoleList,
      yesOrNo,
      yesNoOptions,
      tabPosition: "FRONT", // "0",
      members: [],
      maxDatetime: this.dayjs().format(),
      isSaveLater: true,

      submitted: false,
      tempDate: "",
      tempTime: "",
      injuryDateToUpdate: 0, // timestamp
      injuryTimeToUpdate: 0, // timestamp
      moveToNextStep: false,

      memberId: undefined,

      symptons: undefined,
      concussion: {
        clinicalFeatures: undefined,
        lossOfConsciousness: undefined,
        protectiveAction: undefined,
        impact: undefined,
        balanceDisturbance: undefined,
        dazedOrBlank: undefined,
        unusualBehaviour: undefined,
        confusion: undefined,
        memoryImpairment: undefined,
        playerReports: undefined,
      },
      clinicalFeatures: undefined,
      lossOfConsciousness: undefined,
      protectiveAction: undefined,
      impact: undefined,
      balanceDisturbance: undefined,
      dazedOrBlank: undefined,
      unusualBehaviour: undefined,
      confusion: undefined,
      memoryImpairment: undefined,
      playerReports: undefined,
      natureOfInjury: [],
      howPlayerInjured: undefined,
      howPlayerInjuredOther: "",
      symptons: undefined,
      playerRemoveBy: undefined,
      treatPlayer: undefined,
      playerReferredTo: undefined,
      playerReferredToOther: "",
      immediateCare: undefined,
      immediateCareOther: "",
      firstResponderName: "",
      firstResponderRole: undefined,
      otherSignificants: "",
      tabs: ["FRONT", "BACK"],
      symptomRecordStep: false,
      treatmentStep: false,
      onSaveNotFilled: false,
      errorList: [],
      roles,
      invalidDate: false,
      isSaving: false,
      isSavingDraft: false,
      isSavingSymptoms: false,
    };
  },
  computed: {
    activeRoleType() {
      return this.$store.getters["user/activeRole"].type;
    },
    headIsExits() {
      let exits = _.find(this.natureOfInjury, { bodyPart: "Head/Face/Neck" });

      return exits ? true : false;
    },
    buttonName() {
      // If any of concussion question is answer as Yes go to symptoms record else treatment page
      if (
        this.clinicalFeatures ||
        this.lossOfConsciousness ||
        this.protectiveAction ||
        this.impact ||
        this.balanceDisturbance ||
        this.dazedOrBlank ||
        this.unusualBehaviour ||
        this.confusion ||
        this.memoryImpairment ||
        this.playerReports
      ) {
        return "Continue to Symptoms";
      } else {
        return "Continue";
      }
    },
    isComplete() {
      if (this.tempDate === "" || this.tempTime === "") return false;
      if (
        this.playerRemoveBy === undefined ||
        this.treatPlayer === undefined ||
        this.immediateCare === undefined ||
        this.firstResponderName === "" ||
        this.firstResponderRole === undefined
      )
        return false;

      if (this.treatPlayer === true && !this.playerReferredTo) return false;
      if (this.playerReferredTo === "Other" && !this.playerReferredToOther) return false;
      if (this.injury.immediateCare === "Other" && !this.injury.immediateCareOther) return false;

      // If any of injury is not filled
      const injuryNotFilled = this.natureOfInjury.find(
        (item) =>
          item.injury === undefined || (item.injury === "Other" && item.injuryOther === undefined)
      );

      if (injuryNotFilled) return false;

      //If the injury is Head/face/Neck and symptoms are not marked
      if (this.headIsExits && this.symptons === undefined) return false;

      if (this.howPlayerInjured === undefined) return false;
      if (this.howPlayerInjured === "Other" && this.howPlayerInjuredOther === "") return false;

      return true;
    },
  },

  mounted() {
    this.members = [];
    if (this.injury.scene === 1 && this.injury.meta.teamId && this.injury.meta.matchId) {
      this.$store.commit("root/loading", true);
      this.$http
        .get(
          `/nrl/api/v1/admin/teamlists/teams/${this.injury.meta.teamId}/matches/${this.injury.meta.matchId}`
        )
        .then((res) => {
          const teamlist = res.data.data[0];
          if (teamlist && teamlist.players) {
            this.members = this.members.concat(teamlist.players);
          }

          if (teamlist && teamlist.nonplayers) {
            this.members = this.members.concat(teamlist.nonplayers);
          }
          this.members = this.members.map((member) => {
            var obj = {};
            obj["_id"] = member._id;
            obj["name"] = this.nameFormatter(member);
            return obj;
          });
          this.$store.commit("root/loading", false);
        })
        .catch((err) => {
          this.$store.commit("root/loading", false);
          this.$customError();
        });
    } else if (this.injury.scene > 1) {
      this.$store.commit("root/loading", true);
      // For program Injury :

      if (
        this.activeRoleType === this.roles.programAdmin ||
        this.activeRoleType === this.roles.clubProgramAdmin
      ) {
        this.$http
          .get(`/nrl/api/v1/admin/members/program-members/${this.injury.meta.programId}`)
          .then((progMembers) => {
            const progData = progMembers.data.data;
            this.members = progData.map((member) => {
              var obj = {};
              obj["_id"] = member._id;
              obj["name"] = this.nameFormatter(member);
              return obj;
            });
            this.$store.commit("root/loading", false);
          })
          .catch(() => {
            this.$customError();
          });
      } else {
        this.$http
          .get("/nrl/api/v1/admin/members/my-members/manager")
          .then((response) => {
            this.members = response.data.data.map((member) => {
              var obj = {};
              obj["_id"] = member._id;
              obj["name"] = this.nameFormatter(member);
              return obj;
            });
            this.$store.commit("root/loading", false);
          })
          .catch((error) => {
            this.$store.commit("root/loading", false);
            this.$customError();
          });
      }
    }

    //Injury data
    if (this.injury?.memberId) this.memberId = this.injury.member._id;

    this.tempDate = this.changeDateForFrontend();

    this.tempTime = this.changeTimeForFrontend();

    this.symptons = this.injury.symptons;

    this.concussion = _.clone(this.injury.concussion);

    if (this.injury?.natureOfInjury) this.natureOfInjury = this.injury.natureOfInjury;

    if (this.injury?.playerRemoveBy) this.playerRemoveBy = this.injury.playerRemoveBy;
    this.treatPlayer = this.injury.treatPlayer;
    this.playerReferredTo = this.injury.playerReferredTo;
    if (this.injury?.playerReferredToOther)
      this.playerReferredToOther = this.injury.playerReferredToOther;
    if (this.injury?.immediateCare) this.immediateCare = this.injury.immediateCare;
    if (this.injury?.immediateCareOther) this.immediateCareOther = this.injury.immediateCareOther;
    if (this.injury?.firstResponderName) this.firstResponderName = this.injury.firstResponderName;
    if (this.injury?.firstResponderRole) this.firstResponderRole = this.injury.firstResponderRole;
    if (this.injury?.otherSignificants) this.otherSignificants = this.injury.otherSignificants;
    if (this.injury?.howPlayerInjured) this.howPlayerInjured = this.injury.howPlayerInjured;
    if (this.injury?.howPlayerInjuredOther)
      this.howPlayerInjuredOther = this.injury.howPlayerInjuredOther;
    if (this.injury?.concussion) {
      let {
        clinicalFeatures,
        lossOfConsciousness,
        protectiveAction,
        impact,
        balanceDisturbance,
        dazedOrBlank,
        unusualBehaviour,
        confusion,
        memoryImpairment,
        playerReports,
      } = this.injury.concussion;

      this.clinicalFeatures = clinicalFeatures;
      this.lossOfConsciousness = this.convertBoolToString(lossOfConsciousness);
      this.protectiveAction = this.convertBoolToString(protectiveAction);
      this.impact = this.convertBoolToString(impact);
      this.balanceDisturbance = this.convertBoolToString(balanceDisturbance);
      this.dazedOrBlank = this.convertBoolToString(dazedOrBlank);
      this.unusualBehaviour = this.convertBoolToString(unusualBehaviour);
      this.confusion = this.convertBoolToString(confusion);
      this.memoryImpairment = this.convertBoolToString(memoryImpairment);
      this.playerReports = this.convertBoolToString(playerReports);
    }
  },

  methods: {
    convertBoolToString(fieldName) {
      if (fieldName === undefined) return;
      let newFieldValue = fieldName.toString();
      // By default value when injury already existed with Bool value true
      if (newFieldValue === "true") return (newFieldValue = "Yes -Observed");
      else if (newFieldValue === "false") return (newFieldValue = "No");
      return newFieldValue;
    },
    summaryPageNext() {
      this.moveToNextStep = true;
      this.$emit("next", this.injury, this.moveToNextStep);
    },
    scrollToElement(refName) {
      var element = document.getElementById(refName);
      element.scrollIntoView({ block: "center" });
    },
    next() {
      this.submitted = true;

      if (this.invalidDate) {
        this.scrollToElement("dateOfInjury");
        return;
      }

      if (this.memberId === undefined) {
        this.scrollToElement("memberId");
        return;
      }

      if (this.natureOfInjury.length === 0) {
        this.scrollToElement("bodyPart");
        return;
      }
      this.injury.member._id = this.memberId;
      this.injury.dateOfInjuryStr = this.tempDate;
      this.injury.timeOfInjuryStr = this.tempTime;
      this.injury.symptons = this.symptons;

      this.injury.natureOfInjury = this.natureOfInjury;
      this.injury.playerRemoveBy = this.playerRemoveBy;
      this.injury.treatPlayer = this.treatPlayer;
      this.injury.playerReferredTo = this.playerReferredTo;
      this.injury.playerReferredToOther = this.playerReferredToOther;
      this.injury.immediateCare = this.immediateCare;
      this.injury.immediateCareOther = this.immediateCareOther;
      this.injury.firstResponderName = this.firstResponderName;
      this.injury.firstResponderRole = this.firstResponderRole;
      this.injury.otherSignificants = this.otherSignificants;
      this.injury.howPlayerInjured = this.howPlayerInjured;
      this.injury.howPlayerInjuredOther = this.howPlayerInjuredOther;

      const injuryDateToUpdate = this.dayjs(this.injury.dateOfInjuryStr).valueOf();

      const dt = new Date(`${this.injury.dateOfInjuryStr} ${this.injury.timeOfInjuryStr}`);
      const injuryTimeToUpdate = dt.getTime();

      this.injury.dateOfInjury = injuryDateToUpdate || undefined;
      this.injury.timeOfInjury = injuryTimeToUpdate || undefined;

      // If Body Part is filled and nature of injury is empty => return and show error

      for (const [i, item] of this.injury.natureOfInjury.entries()) {
        if (item.bodyArea && item.bodyPart && item.injury === undefined) {
          this.scrollToElement(`bodyPart${i}`);
          return;
        }
        if (
          (item.bodyArea &&
            item.bodyPart &&
            item.injury === "Other" &&
            item.injuryOther === undefined) ||
          item.injuryOther === null ||
          item.injuryOther === ""
        ) {
          this.scrollToElement(`bodyPart${i}`);
          return;
        }
      }

      if (this.injury.howPlayerInjured === undefined) {
        this.scrollToElement("howPlayerInjured");
        return;
      }
      if (this.injury.howPlayerInjured === "Other" && this.injury.howPlayerInjuredOther === "") {
        this.scrollToElement("howPlayerInjuredOther");
        return;
      }

      //If the injury is Head/face/Neck and symptoms are not marked
      if (this.headIsExits && this.injury.symptons === undefined) {
        this.scrollToElement("symptons");
        return;
      }

      if (this.injury.playerRemoveBy === undefined) {
        this.scrollToElement("playerRemoveBy");
        return;
      }
      if (this.injury.treatPlayer === undefined) {
        this.scrollToElement("treatPlayer");
        return;
      }

      if (this.injury.treatPlayer === true && this.injury.playerReferredTo === undefined) {
        this.scrollToElement("playerReferredTo");
        return;
      }
      if (this.injury.immediateCare === undefined) {
        this.scrollToElement("immediateCare");
        return;
      }

      if (this.injury.firstResponderName === "") {
        this.scrollToElement("firstResponderName");
        return;
      }

      if (this.injury.firstResponderRole === undefined) {
        this.scrollToElement("firstResponderRole");
        return;
      }

      if (this.injury.treatPlayer === true && !this.injury.playerReferredTo) {
        return;
      }
      if (this.injury.playerReferredTo === "Other" && !this.injury.playerReferredToOther) {
        return;
      }
      if (this.injury.immediateCare === "Other" && !this.injury.immediateCareOther) {
        return;
      }

      // If there is no Head Injury , concussion is turned off
      const checkConcussion = this.injury.natureOfInjury.find(
        (obj) => obj.bodyPart == "Head/Face/Neck"
      );
      if (checkConcussion && this.symptons) {
        this.concussion = {
          clinicalFeatures: this.clinicalFeatures,
          lossOfConsciousness: this.lossOfConsciousness,
          protectiveAction: this.protectiveAction,
          impact: this.impact,
          balanceDisturbance: this.balanceDisturbance,
          dazedOrBlank: this.dazedOrBlank,
          unusualBehaviour: this.unusualBehaviour,
          confusion: this.confusion,
          memoryImpairment: this.memoryImpairment,
          playerReports: this.playerReports,
        };
        this.injury.concussion = _.clone(this.concussion);
      } else {
        // If there is no concussion symptoms , concussion and symptom Record questions are reset
        const noData = {};
        this.injury.symptons = false;
        this.injury.concussion = _.clone(noData);
        this.injury.symptomRecord = _.clone(noData);
      }
      this.injury;
      if (this.activeRoleType === this.roles.gamedayAdmin && this.injury) {
        if (this.injury.meta) this.injury.meta = { ...this.injury.meta, gameDayAdmin: true };
        else {
          this.injury.meta = {};
          this.injury.meta.gameDayAdmin = true;
        }
      }

      if (this.injury.natureOfInjury.length > 0) {
        if (this.injury?.member?._id) {
          this.injury.member.name = this.members.find((x) => x._id === this.injury.member._id).name;
          this.injury.memberId = this.injury.member._id;
        }

        this.injury.status = "Completed";
        let { matches, emails, member, ...data } = this.injury;

        if (this.submitted) {
          this.isSaving = true;
          this.$store.commit("root/loading", true);
          if (this.injury._id) {
            this.$http
              .put(`/nrl/api/v1/admin/injury-cases/${this.injury._id}`, this.injury)
              .then((res) => {
                this.moveToNextStep = true;

                this.$emit("next", this.injury, this.moveToNextStep);

                this.submitted = false;
                this.isSaving = false;
                this.$store.commit("root/loading", true);
              })
              .catch(() => {
                this.$store.commit("root/loading", false);
                this.$customError();

                this.submitted = false;
                this.isSaving = false;
                this.$store.commit("root/loading", true);
              });
          } else {
            this.$http
              .post("/nrl/api/v1/admin/injury-cases", this.injury)
              .then((res) => {
                this.injury._id = res.data.data;
                this.moveToNextStep = true;
                this.$emit("next", this.injury, this.moveToNextStep);
                this.isSaving = false;
                this.$store.commit("root/loading", true);
              })
              .catch(() => {
                this.$store.commit("root/loading", false);
                this.isSaving = false;
                this.$store.commit("root/loading", true);
                this.$customError();
              });
          }
        }
      } else {
        this.scrollToElement("bodyPart");
        this.$customError("Could not submit please check entered data");
      }
    },
    onNextStep() {
      clearTimeout(timer);
      timer = setTimeout(() => this.next(), 500);
    },
    addActiveClass(e) {
      e.target.classList.toggle("active");
    },
    chooseBodyParts(bodyType, bodyPart) {
      let exits = _.find(this.natureOfInjury, {
        bodyArea: bodyType,
        bodyPart: bodyPart,
      });
      if (!exits) {
        this.natureOfInjury.push({
          bodyArea: bodyType,
          bodyPart: bodyPart,
          injury: undefined,
          injuryOther: undefined,
        });
      } else {
        this.natureOfInjury = this.natureOfInjury.filter((obj) => {
          return obj.bodyArea == bodyType && obj.bodyPart == bodyPart ? false : true;
        });
      }
    },
    isActive(bodyType, bodyPart) {
      return _.find(this.natureOfInjury, {
        bodyArea: bodyType,
        bodyPart: bodyPart,
      })
        ? "#098255"
        : "#231f20";
    },
    nameFormatter(item) {
      if (item.profile)
        return `${_.get(item, "profile.firstName")} ${_.get(item, "profile.lastName")}`;
      return `${_.get(item, "firstName")} ${_.get(item, "lastName")}`;
    },
    async saveLater() {
      if (this.memberId === undefined) {
        this.onSaveNotFilled = true;
        this.scrollToElement("memberId");
        return;
      }
      this.injury.member._id = this.memberId;
      this.injury.memberId = this.injury.member._id;

      this.injury.dateOfInjuryStr = this.tempDate;
      this.injury.timeOfInjuryStr = this.tempTime;

      this.injury.symptons = this.symptons;
      this.injury.playerRemoveBy = this.playerRemoveBy;
      this.injury.natureOfInjury = this.natureOfInjury;
      this.injury.status = "Pending";
      // If Body Part is filled and nature of injury is empty => return and show error
      // const injuryNotFilled = this.injury.natureOfInjury.findIndex(
      //   item => item.bodyArea && item.bodyPart && item.injury === undefined
      // );
      // if (injuryNotFilled !== undefined) {
      //   this.onSaveNotFilled = true;
      //   console.log(`natureOfInjury.${injuryNotFilled}.injury`);
      //   this.scrollToElement(`bodyPart${injuryNotFilled}`);
      //   return;
      // }

      for (const [i, item] of this.injury.natureOfInjury.entries()) {
        if (item.bodyArea && item.bodyPart && item.injury === undefined) {
          this.onSaveNotFilled = true;
          this.scrollToElement(`bodyPart${i}`);
          return;
        }
      }

      this.injury.treatPlayer = this.treatPlayer;
      this.injury.playerReferredTo = this.playerReferredTo;
      this.injury.playerReferredToOther = this.playerReferredToOther;
      this.injury.immediateCare = this.immediateCare;
      this.injury.immediateCareOther = this.immediateCareOther;
      this.injury.firstResponderName = this.firstResponderName;
      this.injury.firstResponderRole = this.firstResponderRole;
      this.injury.otherSignificants = this.otherSignificants;
      this.injury.howPlayerInjured = this.howPlayerInjured;
      this.injury.howPlayerInjuredOther = this.howPlayerInjuredOther;
      this.concussion = {
        clinicalFeatures: this.clinicalFeatures,
        lossOfConsciousness: this.lossOfConsciousness,
        protectiveAction: this.protectiveAction,
        impact: this.impact,
        balanceDisturbance: this.balanceDisturbance,
        dazedOrBlank: this.dazedOrBlank,
        unusualBehaviour: this.unusualBehaviour,
        confusion: this.confusion,
        memoryImpairment: this.memoryImpairment,
        playerReports: this.playerReports,
      };
      this.injury.concussion = _.clone(this.concussion);

      const {
        matches, emails, member, ...data
      } = this.injury;
      const injuryDateToUpdate = this.dayjs(this.injury.dateOfInjuryStr).valueOf();

      const dt = new Date(`${this.injury.dateOfInjuryStr} ${this.injury.timeOfInjuryStr}`);
      const injuryTimeToUpdate = dt.getTime();

      this.injury.dateOfInjury = injuryDateToUpdate || undefined;
      this.injury.timeOfInjury = injuryTimeToUpdate || undefined;

      if (this.activeRoleType === this.roles.gamedayAdmin && this.injury) {
        if (this.injury.meta) this.injury.meta = { ...this.injury.meta, gameDayAdmin: true };
        else {
          this.injury.meta = {};
          this.injury.meta.gameDayAdmin = true;
        }
      }
      this.isSavingDraft = true;

      if (this.injury._id) {
        await this.$http
          .put(`/nrl/api/v1/admin/injury-cases/${this.injury._id}`, this.injury)
          .then((res) => {
            this.isSavingDraft = false;
            this.$router.push({
              name: "injury-cases",
            });

            this.$customSuccess();
          })
          .catch(() => {
            this.isSavingDraft = false;
            this.$store.commit("root/loading", false);
            this.$customError();
          });
      } else {
        await this.$http
          .post("/nrl/api/v1/admin/injury-cases", this.injury)
          .then((res) => {
            this.injury._id = res.data.data;
            this.isSavingDraft = false;
            this.$router.push({
              name: "injury-cases",
            });

            this.$customSuccess();
          })
          .catch((error) => {
            this.$store.commit("root/loading", false);
            this.isSavingDraft = false;
            if (_.get(error, "response.data.message") === "'memberId' is required") {
              this.$customError("Please select a member");
            } else {
              this.$customError();
            }
          });
      }
    },
    //Time to show on frontend and send to backend
    changeTimeForFrontend(dateTimeData) {
      if (this.injury.timeOfInjuryStr !== "") {
        // When editing the injury
        return this.injury.timeOfInjuryStr;
      } else {
        let dt;
        dt = new Date(); // For current Date and time (this will set the default date and time of injury)
        let timedata = dt.toTimeString();
        const t = timedata.split(" ")[0];
        const t1 = t.split(":");
        const finalTime = t1[0] + ":" + t1[1];
        return finalTime;
      }
    },

    changeTimeForBackend(e) {
      if (e.target.value) {
        this.tempTime = e.target.value;
      }
    },

    // Date to show on frontend and send to backend
    changeDateForFrontend() {
      if (this.injury.dateOfInjuryStr !== "") {
        // When editing the injury
        return this.injury.dateOfInjuryStr;
      }
      let dt;
      dt = new Date(); // For current Date and time (this will set the default date and time of injury)
      const months = dt.getMonth() + 1;
      const dateNumber = dt.getDate();
      if (months < 10) {
        if (dateNumber < 10) {
          return `${dt.getFullYear()}-0${months}-0${dt.getDate()}`;
        }
        return `${dt.getFullYear()}-0${months}-${dt.getDate()}`; // prefix month with "0" like 06 for date 2021-06-11
      }
      if (dateNumber < 10) {
        return `${dt.getFullYear()}-${months}-0${dt.getDate()}`;
      }
      return `${dt.getFullYear()}-${months}-${dt.getDate()}`; // date like 2021-12-11
    },
    changeDateForBackend(e) {
      if (e.target.value) {
        const dateSelected = this.dayjs(e.target.value).valueOf();

        const dt = new Date();
        dt.setHours(0, 0, 0, 0);
        const dateNow = this.dayjs(dt).valueOf();

        if (dateSelected <= dateNow) {
          this.tempDate = e.target.value;
          this.invalidDate = false;
        } else this.invalidDate = true;
      }
    },
    moveTosymptomsOrTreatment() {
      this.submitted = true;
      this.injury.member._id = this.memberId;
      this.injury.memberId = this.injury.member._id;

      this.injury.dateOfInjuryStr = this.tempDate;
      this.injury.timeOfInjuryStr = this.tempTime;

      this.injury.symptons = this.symptons;
      this.injury.playerRemoveBy = this.playerRemoveBy;
      this.injury.natureOfInjury = this.natureOfInjury;

      this.injury.firstResponderRole = this.firstResponderRole;

      this.injury.status = "Pending";

      // If Body Part is filled and nature of injury is empty => return and show error
      const injuryNotFilled = this.injury.natureOfInjury.find(
        (item) => item.bodyArea && item.bodyPart && item.injury === undefined
      );
      if (injuryNotFilled !== undefined) {
        return;
      }

      if (this.clinicalFeatures === undefined) {
        this.scrollToElement("clinicalFeatures");
        return;
      }
      if (this.lossOfConsciousness === undefined) {
        this.scrollToElement("lossOfConsciousness");
        return;
      }
      if (this.protectiveAction === undefined) {
        this.scrollToElement("protectiveAction");
        return;
      }
      if (this.impact === undefined) {
        this.scrollToElement("impact");
        return;
      }
      if (this.balanceDisturbance === undefined) {
        this.scrollToElement("balanceDisturbance");
        return;
      }
      if (this.dazedOrBlank === undefined) {
        this.scrollToElement("dazedOrBlank");
        return;
      }
      if (this.unusualBehaviour === undefined) {
        this.scrollToElement("unusualBehaviour");
        return;
      }
      if (this.confusion === undefined) {
        this.scrollToElement("confusion");
        return;
      }
      if (this.memoryImpairment === undefined) {
        this.scrollToElement("memoryImpairment");
        return;
      }
      if (this.playerReports === undefined) {
        this.scrollToElement("playerReports");
        return;
      }

      this.concussion = {
        clinicalFeatures: this.clinicalFeatures,
        lossOfConsciousness: this.lossOfConsciousness,
        protectiveAction: this.protectiveAction,
        impact: this.impact,
        balanceDisturbance: this.balanceDisturbance,
        dazedOrBlank: this.dazedOrBlank,
        unusualBehaviour: this.unusualBehaviour,
        confusion: this.confusion,
        memoryImpairment: this.memoryImpairment,
        playerReports: this.playerReports,
      };

      this.isSavingSymptoms = true;

      this.injury.concussion = _.clone(this.concussion);
      // If any of concussion question is answer as Yes go to symptoms record else treatment page
      if (
        this.clinicalFeatures ||
        this.lossOfConsciousness ||
        this.protectiveAction ||
        this.impact ||
        this.balanceDisturbance ||
        this.dazedOrBlank ||
        this.unusualBehaviour ||
        this.confusion ||
        this.memoryImpairment ||
        this.playerReports
      ) {
        this.symptomRecordStep = true;
        this.isSavingSymptoms = false;
      } else {
        this.treatmentStep = true;
        this.isSavingSymptoms = false;
      }
    },
    goToTreatmentStep(value, symptomRecord) {
      this.injury.howPlayerInjured = this.howPlayerInjured;
      this.injury.howPlayerInjuredOther = this.howPlayerInjuredOther;
      this.treatmentStep = value;
      this.symptomRecordStep = false;
      this.injury.symptomRecord = Object.assign({}, symptomRecord);
    },
    saveInjuryData(injury, fromTreatmentPage, save) {
      this.injury.playerRemoveBy = injury.playerRemoveBy;
      this.injury.treatPlayer = injury.treatPlayer;
      this.injury.playerReferredTo = injury.playerReferredTo;
      this.injury.playerReferredToOther = injury.playerReferredToOther;
      this.injury.immediateCare = injury.immediateCare;
      this.injury.immediateCareOther = injury.immediateCareOther;
      this.injury.firstResponderName = injury.firstResponderName;
      this.injury.firstResponderRole = injury.firstResponderRole;
      this.injury.otherSignificants = injury.otherSignificants;
      this.injury.howPlayerInjured = injury.howPlayerInjured;
      this.injury.howPlayerInjuredOther = injury.howPlayerInjuredOther;
      if (fromTreatmentPage) {
        if (save) {
          this.injury = injury;
          this.$router.push({
            name: "injury-cases",
          });

          this.$customSuccess();
        } else {
          this.moveToNextStep = true;

          this.$emit("next", this.injury, this.moveToNextStep);
        }
      } else this.saveLater();
    },
  },
  watch: {},
};
</script>

<style>
input[type="date"]::-webkit-inner-spin-button,
input[type="date" i]::-webkit-calendar-picker-indicator {
  margin-left: 4px !important;
  padding-bottom: 6px;
}

input[type="date"]::-webkit-datetime-edit {
  text-transform: uppercase;
}
::-webkit-datetime-edit-text {
  padding: 0 0.3em;
}

input[type="time"]::-webkit-inner-spin-button,
input[type="time" i]::-webkit-calendar-picker-indicator {
  margin-left: 4px !important;
}
input[type="time"]::-webkit-datetime-edit-text {
  padding: 0px;
}

input[type="time"]::-webkit-datetime-edit-hour-field {
  padding: 0 0.3em;
}

input[type="time"]::-webkit-datetime-edit-minute-field {
  padding: 0 0.3em;
}

input[type="radio"] {
  accent-color: rgba(9, 130, 85, 1);
  margin-right: 4px;
  width: 16px;
  height: 16px;
}

input[type="radio"]:checked + span {
  font-weight: 500;
}

button:disabled,
button:hover:disabled {
  cursor: not-allowed;
  background: #e6e6e6;
  color: #fff;
}
.input {
  @apply tw-w-full  tw-pl-2 tw-pr-0.5 tw-text-sm tw-leading-14px tw-text-black  tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none;
}

text {
  @apply tw-w-full tw-pl-2 tw-pr-0.5 tw-text-sm tw-leading-4 tw-text-black  tw-bg-transparent  tw-shadow-none;
}

.error-field {
  @apply tw-text-red-600 !important;
}

select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 2px;
  @apply focus:tw-outline-none tw-text-black;
}

.select_error {
  background-image: url("../../assets/chevron_down_red.svg");
}

.textBox {
  @apply tw-w-full tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

.error {
  @apply tw-placeholder-red-600 tw-text-red-600;
}

.other-enter-active,
.other-leave-active {
  transition: all 0.6s ease-in-out;
}

.other-enter,
.other-leave-to {
  opacity: 0;
}

.parent {
  @apply tw-h-70px tw-relative;
}

/* .parentRadioButtons {
  @apply tw-h-24 tw-relative;
} */

.child {
  @apply tw-w-full tw-absolute tw-bottom-0;
}
</style>
